import { useLayoutEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useSeoOverride } from '../context/SeoContext.jsx';

/**
 * Metadatos SEO por página (título, descripción, Open Graph, canonical).
 * @param {object|null|undefined} options — null/undefined sin título: no sobrescribe la ruta.
 * @param {string|null|undefined} [options.title]
 * @param {string} [options.description]
 * @param {string} [options.image] — ruta o URL de imagen
 * @param {boolean} [options.noIndex]
 * @param {string} [options.type] — og:type, ej. article
 */
export function usePageSeo(options) {
  const { pathname } = useLocation();
  const { setOverride } = useSeoOverride();

  const title = options?.title ?? null;
  const description = options?.description ?? '';
  const image = options?.image ?? '';
  const noIndex = Boolean(options?.noIndex);
  const type = options?.type ?? 'website';
  const enabled = options != null && title != null && title !== '';

  useLayoutEffect(() => {
    if (!enabled) {
      setOverride(null);
      return () => setOverride(null);
    }

    setOverride({
      title,
      description,
      image,
      noIndex,
      type,
      pathname,
    });

    return () => setOverride(null);
  }, [enabled, title, description, image, noIndex, type, pathname, setOverride]);
}
